import { isStarted } from '../../threads/operators/isStarted';
import { connect } from 'react-redux';

// @ts-expect-error untyped file
import { getGdprConsentToProcessEnabledForChatflow } from '../../gdpr/selectors/getGdprConsentToProcessEnabledForChatflow';
import { shouldRequireExplicitCookieConsent } from '../../selectors/widgetDataSelectors/shouldRequireExplicitCookieConsent';
import { getShowGdprConsentToProcess } from '../../gdpr/selectors/getShowGdprConsentToProcess';
// @ts-expect-error untyped file
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import { getShowingHsBranding } from '../../selectors/widgetDataSelectors/getShowingHsBranding';
import UnifiedThreadView from '../components/UnifiedThreadView';
import { shouldShowMeetingsLink } from '../../meetings-links/selectors/shouldShowMeetingsLink';
import { toggleOnAndOffInputFocus } from '../../actions/inputEventActions';
import { selectAttachmentFile } from '../../file-uploads/actions/selectAttachmentFile';
import { getUserHasGivenConsentToProcess } from '../../gdpr/selectors/getHasUserGivenConsentToProcess';
import { getHasChannelSwitchedToEmail } from '../../threads/operators/threadGetters';
import { getShouldUseConsentPromptV2 } from '../../widget-data/selectors/widgetDataSelectors';
import { getIsExitIntentCookiePrompt } from '../../utils/gdprCookieConsentPromptHelpers';
export const mapStateToProps = state => {
  const showingGdprProcess = getGdprConsentToProcessEnabledForChatflow(state) && !getUserHasGivenConsentToProcess(state);
  const renderCookieConsentPrompt = shouldRequireExplicitCookieConsent(state);
  const requiresExplicitConsentToProcess = getShowGdprConsentToProcess(state);
  const shouldUseConsentPromptV2 = getShouldUseConsentPromptV2(state);
  const isExitIntentCookiePrompt = getIsExitIntentCookiePrompt(state);
  const hideMessageEditor = (requiresExplicitConsentToProcess || renderCookieConsentPrompt) && (!shouldUseConsentPromptV2 || renderCookieConsentPrompt && isExitIntentCookiePrompt);
  return {
    shouldShowMeetingsLink: shouldShowMeetingsLink(state),
    isThreadStarted: isStarted(getSelectedThread(state)),
    requiresExplicitConsentToProcess,
    showingGdprProcess,
    renderCookieConsentPrompt,
    showingHsBranding: getShowingHsBranding(state),
    isThreadTransferred: getHasChannelSwitchedToEmail(getSelectedThread(state)),
    shouldHideMessageEditor: hideMessageEditor
  };
};
const mapDispatchToProps = {
  toggleOnAndOffInputFocus,
  selectAttachmentFile
};
export default connect(mapStateToProps, mapDispatchToProps)(UnifiedThreadView);